
import * as defaultImport from "lodash/memoize";
export * from "lodash/memoize";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
